import bus from '@/services/bus.js'

export default {
  install(Vue) {
    Vue.prototype.showModal = (name, data = {}) => {
      bus.$emit('closeAllModals')
      bus.$emit('openModal', {
        name,
        data
      })
    }
  }
}
